/**
 * Angular App Config Service.
 *
 * @file Main Angular's application service provider.
 */
import { Injectable } from '@angular/core';
import { IConfig } from '../models/config.model';

@Injectable({
    providedIn: 'root'
})
export class ConfigService {
 
  private _config: IConfig;

  public setConfig(config: IConfig) {
    console.log("ConfigService:SetConfig");
    console.log(config);

    this._config = {...config};
  }

  public getProductConfig() : any {
    return (this._config && this._config.product) ? {...this._config.product} : {};
  }

  public getCookiesConfig() : any {
    return (this._config && this._config.cookies) ? {...this._config.cookies} : {};
  }

  constructor () {
  }

}
 